<div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
  <div class="offcanvas-header d-flex justify-content-between align-items-center">
    <h5 class="mb-0" id="offcanvasRightLabel">История записей</h5>
    <button type="button" class="btn-close-icon" data-bs-dismiss="offcanvas" aria-label="Close">
      <fa-icon [icon]="faCircleXmark" class="close-icon"></fa-icon>
    </button>
  </div>

  <div class="offcanvas-body">
    @if (isLoading) {
      <div class="d-flex justify-content-center align-items-center py-5">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    }

    @if (!isLoading && (!historyData || historyData.length === 0)) {
      <div class="text-center py-5">
        <strong>Нет доступной истории</strong>
      </div>
    }

    @if (!isLoading && historyData && historyData.length) {
      @for (item of historyData; track trackById) {
        @if (item.$eventType === 'notification' && hasDisplayableTracks(item)) {
          <div class="container-history">
            <div class="dot"></div>

            <div class="history-header">
              <h5 class="history-title">
                {{ item.title | translate }}:
                <span class="history-time">{{ getTimeDifference(item) }}</span>
              </h5>
            </div>

            <div class="history-tracks">
              @for (track of getItemTracks(item); track trackByName) {
                @if (shouldDisplayTrack(track)) {
                  <p class="track-item">
                    <strong class="track-name">{{ getFieldTitle(track.name) }}</strong>
                    :
                    @if (track.oldDisplayValue || track.displayValue) {
                      <span class="track-value">
                        @if (track.oldDisplayValue) {
                          <span class="old-value" [title]="track.oldDisplayValue | formatValue">
                            {{ track.oldDisplayValue | formatValue }}
                          </span>
                          <fa-icon [icon]="faArrowRight" class="mx-1"></fa-icon>
                        }
                        @if (track.displayValue) {
                          <span class="new-value" [title]="track.displayValue | formatValue">
                            {{ track.displayValue | formatValue }}
                          </span>
                        }
                      </span>
                    } @else if (track.oldValue || track.value) {
                      <span class="track-value">
                        @if (track.oldValue) {
                          <span class="old-value" [title]="track.oldValue | formatValue">
                            {{ track.oldValue | formatValue }}
                          </span>
                          <fa-icon [icon]="faArrowRight" class="mx-1"></fa-icon>
                        }
                        @if (track.value) {
                          <span class="new-value" [title]="track.value | formatValue">
                            {{ track.value | formatValue }}
                          </span>
                        }
                      </span>
                    }
                  </p>
                }
              }
              @if (item.$author) {
                <strong class="track-name">{{ 'author' | translate }}</strong>
                :
                <span class="track-value" [title]="item.$author.name">{{ item.$author.name }}</span>
              }
            </div>
          </div>
        }
      }
    }
  </div>
</div>
